export default __webpack_public_path__ + "static/team-gabriella-6e46e94b06fbd0648fd5b8f1921edb95.png";